export default __webpack_public_path__ + "static/media/onprofit.8ffa67ae.png";